module.exports = __webpack_public_path__ + "img/1.52fa7947.png";